// <script data-ad-client="ca-pub-3147865692631757" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>

$w.onReady(function () {
	// Write your code here
});